import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./floating_booking_bar.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
